module.exports = __webpack_public_path__ + "static/media/demantur.db2fbedf.svg";